<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-session-expiry-banner></app-session-expiry-banner>
</ion-app>
